const ua = navigator.userAgent
let flag
let fn: any
const isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
if (isIOS) {
  document.body.addEventListener('focusin', () => {
    // 软键盘弹起事件
    flag = true
    clearTimeout(fn)
  })
  document.body.addEventListener('focusout', () => {
    // 软键盘关闭事件
    flag = false
    if (!flag) {
      fn = setTimeout(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      })
    }
  })
}

window.isIOS = isIOS

export {}
